module.exports = __webpack_public_path__ + "img/splash3.f311ac46.png";